import { connect } from "react-redux";

import { AbsoluteModelPath } from "../../../../../Common/ModelPath/ModelPath";
import { FullFormState } from "../../../Engine/Core/Store/FullFormState";
import { ViewModelSelect } from "../../../Helpers/StateAccessors/ViewModelSelect";
import { PathResolver, withResolvePaths } from "../../withResolvePaths";
import { withViewModelSelect } from "../../withViewModelSelect";

import { JoinBlock } from "./JoinBlock";

export interface JoinBlockOwnProps {
    itemBindingPaths: AbsoluteModelPath[];
    resolvePath: PathResolver;
    viewModelSelect: ViewModelSelect;
}

const mapStateToProps = (state: FullFormState, ownProps: JoinBlockOwnProps) => ({
    itemFillStates: ownProps.itemBindingPaths
        .map(x => ownProps.resolvePath(x))
        .map(x => ownProps.viewModelSelect.pathViewModelOrUndefined(state, x)?.value)
        .map(x => x != undefined && x !== ""),
});

export const JoinBlockContainer = withResolvePaths(withViewModelSelect(connect(mapStateToProps)(JoinBlock)));
